{
  "enemyHp": 1,
  "enemyFireRate": 1,
  "bulletSpeed": 1,
  "spawnDensity": 1
}
